<template>
  <div>
  </div>
</template>

<script>
export default {
  filters: {
  },
  data() {
    return {
      requrl: this.$route.query.requrl
    };
  },
  computed: {
  },
  created() {
    window.open(this.requrl)
  },
  mounted() { 
  },
};
</script>
<style scoped lang="scss">
</style>